import * as React from 'react';
import {Text, View} from 'react-native';
import {useSelector} from 'react-redux';
import {sendCodeResponseSelector} from '../../../redux/selectors/login';
import {Button} from '../../../shared/components/button';
import {useStyles} from '../../../shared/hooks/styles';
import {maskPrivateData, PrivateDataMaskType} from '../../../shared/pipes';
import {DeviceSize} from '../../../shared/theme/helpers';
import {CountDownTimer, CountDownTimerRefProps} from '../components/countDownTimer';

const countdownTimerContainerWidthDesktop = 320;

interface Props {
  onRefresh: () => Promise<boolean>;
  containerWidthDesktop?: number;
}

export const EmailFields: React.FC<Props> = ({onRefresh}) => {
  const sendCodeResponse = useSelector(sendCodeResponseSelector());
  const [resendButtonDisabled, setResendButtonDisabled] = React.useState(true);
  const timerRef = React.useRef<CountDownTimerRefProps | null>(null);
  const styles = useStyles(({theme, mediaOnly}) => {
    return {
      container: {
        width: '100%',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'center',
      },
      message: {
        ...mediaOnly(
          DeviceSize.mobile,
          {
            ...theme.fonts.bodySmallLight,
            maxWidth: 240,
            marginTop: 20,
            marginBottom: 30,
          },
          {
            ...theme.fonts.h6Light,
            width: 397,
            maxWidth: 397,
            marginBottom: 10,
          },
        ),
        textAlign: 'center',
      },
      messageBold: {
        ...mediaOnly(
          DeviceSize.mobile,
          {
            ...theme.fonts.bodySmall,
          },
          {
            ...theme.fonts.h6,
          },
        ),
      },
      button: {
        width: '100%',
        maxWidth: 240,
      },
      countDownContainer: mediaOnly(DeviceSize.desktop, {
        flexDirection: 'row',
        justifyContent: 'center',
        width: countdownTimerContainerWidthDesktop,
      }),
    };
  });

  const message = React.useMemo(() => {
    if (typeof sendCodeResponse?.message !== 'string') {
      return sendCodeResponse?.message;
    }

    return sendCodeResponse?.message.split(' ').map((item, index) => {
      const prefix = index ? ' ' : '';
      const key = `${item}-${index}`;
      if (item.match(/.+@.+/)) {
        return (
          <Text key={key} style={styles.messageBold}>
            {prefix}
            {maskPrivateData(item, {maskType: PrivateDataMaskType.email})}
          </Text>
        );
      }
      return (
        <React.Fragment key={key}>
          {prefix}
          {item}
        </React.Fragment>
      );
    });
  }, [sendCodeResponse?.message, styles.messageBold]);

  return (
    <View style={styles.container}>
      <Text style={styles.message}>{message}</Text>
      <View style={styles.countDownContainer}>
        <CountDownTimer
          ref={timerRef}
          until={sendCodeResponse?.resendCountdown || 300}
          onTimerEnd={() => setResendButtonDisabled(false)}
        />
      </View>
      <Button
        id='registration-resend'
        style={styles.button}
        disabled={resendButtonDisabled}
        type='secondary'
        text='Отправить повторно'
        onPress={async () => {
          setResendButtonDisabled(true);
          if (await onRefresh()) {
            timerRef.current?.resetTimer();
          } else {
            setResendButtonDisabled(false);
          }
        }}
      />
    </View>
  );
};
